/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { SingleSelectDropDown, Switch } from '@insticator/insticator-ui'
// styles
import injectSheet from 'react-jss'
import styles from './fonts_styles'
import { Tip } from '@insticator/insticator-ui/dist/material';

const typefaceOptions = [
  { name: 'Decorative & Plain', value: 'DECORATIVE_AND_PLAIN'},
  { name: 'Plain', value: 'PLAIN'},
  { name: 'Decorative', value: 'DECORATIVE'}
]

const typeFaceMap = {
  DECORATIVE_AND_PLAIN: typefaceOptions[0],
  PLAIN: typefaceOptions[1],
  DECORATIVE: typefaceOptions[2]
}

const sizeOptions = [
  { name: 'Small', value: 'SMALL'},
  { name: 'Medium', value: 'MEDIUM'},
  { name: 'Large', value: 'LARGE'}
]

const sizeMap = {
  SMALL: sizeOptions[0],
  MEDIUM: sizeOptions[1],
  LARGE: sizeOptions[2]
}
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : FONTS ~~~~~~~~~~ ========== */
const Fonts = injectSheet(styles)((props) => {

  const { siteTheme, setSiteThemeConfig } = props

  const handleFontStyleChange = style => {
    setSiteThemeConfig('useSystemFont', style)
  }

  const handleFontSizeChange = opt => {
    setSiteThemeConfig('fontSize', opt.value)
  }

  const handleFontTypefaceChange = opt => {
    setSiteThemeConfig('fontTypeface', opt.value)
  }

  return (
    <SectionGroupV2 
      title={'Fonts'} 
      description={'Match your sites text style by selecting a similar typeface and size.'}
      indented
      direction={'column'}
    >
      <Space direction={'column'}>
        <Space gap={8} alignItems={'center'}>
          <Switch 
            on={siteTheme.useSystemFont} 
            handleClick={() => handleFontStyleChange(!siteTheme.useSystemFont)} 
          />
          <span>Optimize performance</span>
          <Tip 
            content={`
              Uses standard system fonts from a users device instead of a custom webfont. 
              This will improve download speed and CWV scores but may not be as aesthetically pleasing.
            `}
            label={''}
          />
        </Space>
      </Space>
      <Space>
        <SingleSelectDropDown 
          label={'Typeface'}
          name={typeFaceMap[siteTheme.fontTypeface].name} 
          searchable={false} 
          onSelect={handleFontTypefaceChange}
          items={typefaceOptions}
        />
        <SingleSelectDropDown 
          label={'Size'}
          name={sizeMap[siteTheme.fontSize].name} 
          searchable={false} 
          onSelect={handleFontSizeChange}
          items={sizeOptions}
        />
      </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Fonts